"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasWindow = void 0;
var hasWindow_1 = require("./hasWindow");
Object.defineProperty(exports, "hasWindow", { enumerable: true, get: function () { return __importDefault(hasWindow_1).default; } });
//# sourceMappingURL=index.js.map